import HolidayCard from "./holidayCard"
export default HolidayCard;